import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, } from "../../components"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, addToast, Select, SelectItem, Chip, Card, CardBody, Divider, Modal, NumberInput, Spinner } from "@heroui/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_BILL_TYPE, ENUM_CERTIFIEDLAB, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_TRADE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faClose, faDownload, faDownLong, faFile, faFileEdit, faGem, faPenToSquare, faPlus, faSave, faSearchPlus, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid } from "@mui/x-data-grid"
import { calculateTotal, funCheckNumber, scrollInput, stickyBottomClass, stickyParentClass } from "../../Utility/utility"
import { Box, Drawer, } from "@mui/material"
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
import { resetDetailParams } from "../../state/stockEntrySlice"
import { useModalToast } from "../../components/modalToast/ModalToastContext"

const ImportBills = () => {
    const { compCode, isMultipleCompany, compState, startDate, endDate } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.stockEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [entryLabel, setEntryLabel] = useState("")
    const [selBillType, setSelBillType] = useState('S')
    const [selTradeOf, setSelTradeOf] = useState("P")
    const [selPktType, setSelPktType] = useState("SNG")
    const [naviCode, setnaviCode] = useState()
    const [modSettingParams, setModSettingParams] = useState("")
    const [rows, setRows] = useState([])
    const [allRows, setAllRows] = useState([])
    const [openDrawer, setOpenDrawer] = useState(false);
    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [selectedRowId, setSelectedRowId] = useState("")
    const [selImportItem, setSelImportItem] = useState("")
    const [btnLabel, setBtnLabel] = useState("Add")
    const { strdtype, sptype } = useParams();
    const [isExcelImport, setIsExcelImport] = useState(true)
    const [CurrencySetting, setCurrencySetting] = useState("")
    const [lwRatioData, setLwRatioData] = useState([])
    const [mktLotNo, setMktLotNo] = useState("0")
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const fileInputRef = useRef(null)
    const [submitBtnId, setSubmitBtnId] = useState("")
    const [dupMarketingCode, setDupMarketingCode] = useState([])
    const [blankParty, setBlankParty] = useState("")
    const [outOfStockCode, setoutOfStockCode] = useState([])
    const [isMFGIdSingleColum, setIsMFGIdSingleColum] = useState(true)
    const [isMKTIdSingleColum, setIsMKTIdSingleColum] = useState(true)
    const [totalExcelPacket, setTotalExcelPacket] = useState(0)
    const [searchText, setSearchText] = useState("")
    const dispatch = useDispatch()
    const { show } = useModalToast()
    const submitLockRef = useRef(false)


    const { data: masterData = [], isPending: isPendingData, mutate: filterMasterData } = usePost({
        url: apiRoute.memoEntry.entryMasterData,
        queryKey: "masterDatastck",
        onSuccessTasks: (data) => {
            // if (data && Object.keys(data).length > 0) {
            //     if (data.bookMaster.length > 0) {
            //         setFormData({ ...formData, [formField.bookAcId]: data.bookMaster[0].Party_Id, [formField.stockType]: selPktType != "SNG" ? ENUM_STOCK_TYPE.OpeningStock : "" })
            //         funGenVouNo(data.bookMaster[0].Party_Id)
            //     }
            // }
        }
    })

    const { data: labData = [], } = useFetchWithBody({
        url: apiRoute.stockEntry.getLabList,
        queryKey: "LabDataList",

    })
    const { data: stockcheck = [], mutate: checkStock } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.getOutStockLotPkt,
        queryKey: "fetchOuttockData",


    })
    const { isPending: isPendingStkPos, data: stkWithPosData = [], mutate: findStockWithPosition } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.findStokeWithPosition,
        queryKey: "fetchStockwithPositionData",
    })
    const refInputPktNo = useRef(null)
    const refInput = useRef(null)

    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.invoiceEntry.funImportBills,
        queryKey: "funAddUpdateStock",
        onSuccessTasks: (data) => {
            console.log(data)

            if (data && data.length > 0) {
                let content = `Import Errors ( ${data.length} )`
                content += "\n\n";
                content += data.map(item => item?.stockid + ':' + item.msg).join("\n\n");
                const pkts = data.map(item => item.stockid).join(",");

                content += "\n\n";
                content += `Total Success:${excelData.length - data.length}`;



                show(<div><div className="">The following packets encountered issues during import</div> <div  style={{height:"200px",overflow:"scroll"}} className="text-blue-700 font-semibold"     >{pkts}</div></div>)
                const blob = new Blob([content], { type: "text/plain" });
                const url = URL.createObjectURL(blob);

                const date = new Date().toISOString().slice(0, 10);
                // format: YYYY-MM-DD

                const fileName = `InvoiceUploadLog_${date}.txt`;

                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
            else {
                show("Imported Successfully")
            }
            dispatch(resetDetailParams());
            if (submitBtnId == 'btnSaveNew') {
                setFormData(emptyFormField)
                setRows([])
                setAllRows([])
                window.location.reload();
            }
            else
                submitLockRef.current = false;
        }
    })

    const { isPending: isLoadingDupPktList, data: dupPktList = [], mutate: funGetDupPktList } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.getDupPktList,
        queryKey: "funDupPktStock",
    })

    const { data: excelTempData, mutate: filterXlTemplate } = usePost({
        url: apiRoute.stockEntry.getExcelTemplate,
        queryKey: "funExcelTemplateStock",
        // inputData: {
        //     tempname: selPktType=='SNG'?g'StockImport':'StockImportMix'
        // }
    })

    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingStockItem",
    })






    const { data: dupLotPktNo = [], mutate: funChkPktLotNo } = usePostMutateWithSuccess({
        url: apiRoute.memoEntry.checkLotPktNo,
        queryKey: "checkLotNoPktData",

    })

    const { data: mktLotNoData = [], mutate: getMktLotNo } = usePost({
        url: apiRoute.memoEntry.fetchMktlotNo,
        queryKey: "getmktlocdeData",
        onSuccessTasks: (data) => {
            if (!isUseMfgNoAsMktno) {
                if (data && data.length <= 0) {
                    if (!toast.isActive("mktlcode")) {
                        toast.error("Lot No Series Not Found", {
                            "position": "top-center",
                            toastId: "mktlcode"
                        })
                    }
                    setFormData({ ...formData, [formField.memoDate]: null })
                }
                else
                    setMktLotNo(data[0].Mkt_LCode)
            }
            else
                setMktLotNo('0')
        }

    })

    const { data: dupRoughNo = [], mutate: funChkRoughNo } = usePost({
        url: apiRoute.memoEntry.checkRoughNo,
        queryKey: "checkRoughtNo",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                if (data[0].count > 0) {
                    setStockFormData({ ...stockFormData, [RowsField.lotNo]: "" })
                    if (!toast.isActive('toats_chkRoughno')) {
                        toast.error("Duplicate Rough No not Allow", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toats_chkRoughno",


                        })
                    }

                }
            }

        }

    })

    const { mutate: funChkRoughRef } = usePost({
        url: apiRoute.memoEntry.checkRoughRef,
        queryKey: "checkRoughRef",
        onSuccessTasks: (data) => {

            if (data && data.length > 0) {
                if (data[0].totalcount <= 0) {
                    const id = selectedRowId ?? 0

                    const updatedRows = rows.filter((row) => row.id !== id)
                    let DeletedRow = rows.filter((row) => row.id == id)
                    const rearrangedRows = updatedRows.map((row, index) => {

                        return {
                            ...row,
                            id: index + 1, // Reassign IDs to start from 1 again
                        }
                    })

                    setRows(rearrangedRows)
                    setAllRows(rearrangedRows)
                    setDeletedItemRows([...deletedItemRows, ...DeletedRow])
                }
                else {
                    toast.error("You can't delete as it locked", {
                        position: "top-center",
                        "className": "toast-error",
                    })
                }
            }

        }

    })
    const isSinglePacket = () => {
        if (sptype != "") {
            if (sptype == URIEncrypt.SinglePacket)
                return true
            else
                return false
        }
        else
            return false
    }

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

//show(<div className="text-red-700 text-sm" >Out Of Stock Lot No. & Pkt No. <div style={{height:"200px",overflow:"scroll"}} className="text-gray-700 list-disc ml-5 "></div></div>)
        const modName = ""

        filterMasterData({
            data: {
                compcode: compCode.join(","),
                tradeof: selTradeOf,
                billtype: selBillType,
                pkttype: selPktType

            }
        })
        filterXlTemplate({
            data: {
                tempname: selPktType == 'SNG' ? 'InvoiceImport' : 'StockImportMix'
            }
        })
        filterModSetting({
            data: {
                page_mod: modName,
                master_mod: ENUM_MOD_NAME.GeneralSettings
            }
        })



    }, [])

    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS)
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, generalData);
            setIsUseMfgNoAsMktno(mktSetting)
            setIsMFGIdSingleColum(getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.IsMfgIDSingleColumn, generalData) ?? true);
            setIsMKTIdSingleColum(getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.IsMktIDSingleColumn, generalData) ?? true);

            setModSettingParams({
                Visibility: {
                    [RowsField.itemCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.itemDetail]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ItemDetail, modData) ?? false,
                    [RowsField.lwRatio]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                },
                Mandatory: {
                    [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.itemDetail]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.ItemDetail, modData) ?? false,
                    [RowsField.lwRatio]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                    [RowsField.reportNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,

                },


            })
        }

    }, [modSetting])

    const net_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const net_AmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dAmount",
            }),
        [rows]
    )
    const total_Weight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "weight",
            }),
        [rows]
    )
    const total_Rate = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "rate",
            }),
        [rows]
    )
    const total_Pcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "pcs",
            }),
        [rows]
    )
    const formField = {
        memoNo: "memoNo",
        transId: "transId",
        memoDate: "memoDate",
        locationId: "locationId",
        bookAcId: "bookAcId",
        stockType: "stockType",
        lab: "lab"
    }
    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.memoDate)
            acc[key] = new Date()
        else if (key == formField.transId)
            acc[key] = 0

        else acc[key] = ""
        return acc
    }, {})

    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const RowsField = {
        detailId: "detailId",
        itemCode: "itemCode",
        itemName: "itemName",
        itemDetail: "itemDetail",
        lotNo: "lotNo",
        pktNo: "pktNo",
        sLotNo: "sLotNo",
        sPktNo: "sPktNo",
        updateLotNo: "updateLotNo",
        updatePktNo: "updatePktNo",
        shapeCode: "shapeCode",
        shapeName: "shapeName",
        colorCode: "colorCode",
        colorName: "colorName",
        purityCode: "purityCode",
        purityName: "purityName",
        sizeCode: "sizeCode",
        sizeName: "sizeName",
        lwRatio: "lwRatio",
        pcs: "pcs",
        weight: "weight",
        rate: "rate",
        dRate: "dRate",
        convRate: "convRate",
        dAmount: "dAmount",
        amount: "amount",
        cut: "cut",
        dia: "dia",
        lab: "lab",
        bPcs: "bPcs",
        bWeight: "bWeight",
        reportNo: "reportNo",
        rapRate: "rapRate",
        lessPer: "lessPer",
        stnLength: "stnLenth",
        tblDepth: "tblDepth",
        flrn: "flrn",
        crwnAngle: "crwnAngle",
        certiDate: "certiDate",
        certiNo: "certiNo",
        stoneId: "stoneId",
        gridMktNo: "gridMktNo",
        stkLotNo: "stkLotNo",
        stkPktNo: "stkPktNo",
        isCertiDataExist: "isCertiDataExist"

    }
    const noField = [RowsField.detailId, RowsField.bPcs, RowsField.bWeight, RowsField.pcs, RowsField.weight, RowsField.rate, RowsField.amount, RowsField.tablePer
        , RowsField.rapRate, RowsField.lessPer, RowsField.dia, RowsField.convRate, RowsField.dRate, RowsField.dAmount, RowsField.isCertiDataExist
    ]
    const emptyRowsField = Object.keys(RowsField).reduce((acc, key) => {
        if (noField.includes(key))
            acc[key] = 0
        else if (key == RowsField.certiDate)
            acc[key] = null
        else acc[key] = ""
        return acc
    }, {})
    const [stockFormData, setStockFormData] = useState({
        ...emptyRowsField
    })

    const inputBoxes = {
        // Row1: [

        //     {
        //         id: formField.memoDate,
        //         name: formField.memoDate,
        //         placeholder: "Bill Date.",
        //         type: ENUM_INPUT_TYPE.date,
        //         size: "sm",
        //         label: "",
        //         isrequired: true,
        //     },],
        Row2: [
            {
                id: formField.bookAcId,
                name: formField.bookAcId,
                placeholder: "Book Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.bookMaster ? masterData?.bookMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                id: formField.locationId,
                name: formField.locationId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.locationMaster ? masterData?.locationMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
        ],

    }


    const getLwRatioByShape = (shape) => {
        if (masterData && Object.keys(masterData).length > 0)
            return masterData?.lwMaster.filter((ele) => ele.S_Code == shape)
        else
            return []
    }

    const funGetName = (columName, value) => {
        let name_val = ""
        let tempData = []
        let findData = []

        if (masterData && Object.keys(masterData).length > 0) {

            if (columName == RowsField.itemCode && value != "" && value != null) {
                tempData = masterData.itemMaster
                findData = tempData.filter((ele) => ele.Item_Code == value)
                name_val = findData[0]?.Item_Desc ?? ''
            }
            else if (columName == RowsField.shapeCode && value != "" && value != null) {
                tempData = masterData.shapeMaster
                findData = tempData.filter((ele) => ele.S_Code == value)
                name_val = findData[0]?.S_Name ?? ''
            }
            else if (columName == RowsField.colorCode && value != "" && value != null) {
                tempData = masterData.colorMaster
                findData = tempData.filter((ele) => ele.Sh_Code == value)
                name_val = findData[0]?.Sh_Name ?? ''
            }
            else if (columName == RowsField.purityCode && value != "" && value != null) {
                tempData = masterData.purityMaster
                findData = tempData.filter((ele) => ele.Q_Code == value)
                name_val = findData[0]?.Q_Name ?? ''
            }
            else if (columName == RowsField.sizeCode && value != "" && value != null) {

                tempData = masterData.sizeMaster
                findData = tempData.filter((ele) => ele.Sz_Code == value)
                name_val = findData[0]?.Sz_Name ?? ''
            }
        }

        return name_val;

    }
    useEffect(() => {
        if (masterData && Object.keys(masterData).length > 0) {
            setLwRatioData(masterData.lwMaster)
        }
    }, [masterData])



    const handleChange = (e) => {
        const { value, id, } = e.target
        setFormData({ ...formData, [id]: value })
    }



    const [errors, setErrors] = useState({})



    const funMktLotNo = (date) => {

        if (isNewEntry && !isUseMfgNoAsMktno && selPktType == 'SNG') {
            getMktLotNo({
                data: {
                    chaldate: date
                }
            })
        }
    }
    useEffect(() => {
        funMktLotNo(dayjs(Date()).format("YYYY-MM-DD"))

    }, [isUseMfgNoAsMktno])
    const [isFocus, setIsFocus] = useState(false)


    // useEffect(() => {
    //     if (selPktType == 'SNG') {
    //         document.querySelector("#pktNo").focus();
    //         if (refInputPktNo.current)
    //             refInputPktNo.current.focus()
    //     }
    // }, [isFocus])
    const handleAutoCompleteChange = (value, id, name) => {



        setFormData({ ...formData, [name]: value })



    }

    const isDuplicateExcludingId = (target, arr) => {
        return arr.some(item => {
            // Skip the same object by id
            const excludeKey = [RowsField.pcs, RowsField.weight, RowsField.weight, RowsField.amount]
            if (item.id === target.id) return false;

            // Compare all keys except 'id'
            return Object.keys(target).every(key => {
                if (selectedRowId && selectedRowId > 0) {
                    if (excludeKey.includes(key) && key != 'id') return true;
                }
                else
                    if (excludeKey.includes(key)) return true;
                return item[key] === target[key];
            });
        });
    };



    const setCurrencyColumnVisiblity = (column) => {

        const RsCol = [RowsField.rate, RowsField.amount]
        const DCol = [RowsField.dRate, RowsField.dAmount, RowsField.convRate]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return false
    }

    const itemGridHeadClass = "bill-grid-style"

    const funSubmit = () => {
        const validate_form = "" // validateForm()
        const grid_msg = ""//isExcelImport ? "" : ValidateGrid()

        if (grid_msg == "") {
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    list_data: excelData,
                    trade_of: selTradeOf,
                    item_code: selImportItem,
                    bill_type: selBillType,
                    location_id: formData?.locationId,
                    book_id: formData?.bookAcId,
                    pkt_type: selPktType,
                    login_userid: user.username,
                    fystart_date: dayjs(startDate).format("YYYY-MM-DD"),
                    fyend_date: dayjs(endDate).format("YYYY-MM-DD"),
                    rec_status: 2
                }
            })
        }
        else {
            submitLockRef.current = false;
            toast.error(grid_msg, {
                "position": "top-center"
            })
        }
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        setSubmitBtnId(e.nativeEvent.submitter.id)
        // console.log(isUseMfgNoAsMktno, mktLotNo, "sub")

        if (isExcelImport && excelData.length <= 0) {
            show(<div className="text-red-700 text-sm" >No Data Found To Upload. <div className="text-gray-700 list-disc ml-5">
                {dupMarketingCode?.length > 0 ? "Duplicate Lot No / Pkt No found in stock. Only new   Lot/Pkt entries are allowed. Existing Lot/Pkt cannot be uploaded." : ""}
            </div></div>)
            if (fileInputRef.current) {
                fileInputRef.current.value = ''; // Clear file input
            }
            return;
        }
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        if (selPktType == 'SNG') {
            let lotPktString = rows
                .filter(item => item.lotNo && item.pktNo && item.detailId == 0)
                .map(item => `${item.lotNo}-${item.pktNo}`)
                .join(",");

            if (lotPktString && lotPktString.length != "" && lotPktString.length > 0) {
                funGetDupPktList({
                    data: {
                        compcode: compCode.join(","),
                        list: lotPktString,
                        Ismfglist: 0,
                        Ischkmfgmkt: 0
                    },
                    onSuccess: (data) => {
                        if (!submitLockRef.current) return; // 🚫 ignore stale calls
                        if (data && data.length > 0) {
                            const result = data
                                .map(item => `${item.L_CODE}-${item.PKTNO}`)
                                .join(",");
                            show(<div className="text-red-700 text-sm" >Duplicate Stock Lot No. & Pkt No. {<div className="text-gray-700 list-disc ml-5">
                                {result}
                            </div>}</div>)
                            submitLockRef.current = false;
                            return;

                        }
                        else {
                            funSubmit()
                        }


                    }
                });
            }
            else
                funSubmit()
            // console.log(ExcelColMap)
        }
        else {
            funSubmit();
        }
    }




    const handleCheckChange = (value) => {
        setIsExcelImport(value)
        setRows([])
        setAllRows([])
    }
    const [excelData, setExcelData] = useState([]);


    const columnMapping = useMemo(() => {
        const d = excelTempData.map((row) => {
            return {
                [row.xl_col_no]: row.tb_col_name
            }
        })

        const flipped = d.reduce((acc, obj) => {
            const [key, value] = Object.entries(obj)[0];
            acc[value] = key;
            return acc;
        }, {});
        return flipped
    }, [excelTempData])


console.log(blankParty)
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        //const StockSingleColumn = 0
        reader.onload = (event) => {

            const binaryStr = event.target.result;

            const workbook = XLSX.read(binaryStr, {
                type: 'binary',
                cellDates: true
            });

            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            const excelDateToJSDate = (serial) => {
                const excelEpoch = new Date(1899, 11, 30);
                const jsDate = new Date(excelEpoch.getTime() + serial * 86400000);

                return jsDate.toLocaleDateString("en-GB");
            };

            const formattedData = jsonData.map((row) => ({
                ...row,
                Date: typeof row.Date === "number"
                    ? excelDateToJSDate(row.Date)
                    : row.Date
            }));



            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const dataRows = rows.slice(1);
            const headers = rows[0];

            // console.log(columnMapping,rows[0], Object.keys(columnMapping).length, headers.length)

            let spktno = ''
            let slcode = ''
            setTotalExcelPacket(dataRows.length)

            const dbDuplicateSet = new Set();
            if (headers.length == Object.keys(columnMapping).length) {

                const mapped = dataRows.filter((r) => r.length !== 0).map((row, ind) => {

                    //if (row.length > 0) {
                    const finalData = Object.entries(columnMapping).map(([key, value]) => {

                        if (key == 'stoneid' && selPktType == 'SNG') {
                            let val = row[Number(value.toString()) - 1] ?? ''

                            if (val != "") {

                                if (String(val).includes("-")) {
                                    // const sData = val.split('-');
                                    const [left, right] = String(val).split("-");

                                    if (left?.trim() && right?.trim()) {
                                        // if (sData && sData.length > 0) {
                                        return { l_code: left, pktno: right, [key]: row[Number(value.toString()) - 1] ?? null }
                                    }
                                    else {

                                        toast.error("Invalid Stock Format LotNo & PktNo Should Not be Empty'  ", {
                                            "position": "top-center",
                                            "className": "toast-error",
                                            "toastId": "stkial"
                                        })
                                        if (fileInputRef.current) {
                                            fileInputRef.current.value = ''; // Clear file input
                                        }
                                        return { [key]: row[Number(value.toString()) - 1] ?? null }
                                    }
                                }
                                else {
                                    if (toast && !toast.isActive("stkinval")) {
                                        toast.error("Invalid Stock Format LotNo & PktNo Must Be Seperated Using ' - '  ", {
                                            "position": "top-center",
                                            "className": "toast-error",
                                            "toastId": "stkinval"
                                        })
                                    }
                                    if (fileInputRef.current) {
                                        fileInputRef.current.value = ''; // Clear file input
                                    }
                                    return { [key]: row[Number(value.toString()) - 1] ?? null }
                                }
                            }
                        }

                        else {
                            return {
                                [key]: row[Number(value.toString()) - 1] ?? null
                            }
                        }


                    })
                    //  }
                    //console.log(finalData)
                    const result = finalData.reduce((acc, obj) => {
                        if (obj && typeof obj === 'object') {
                            Object.entries(obj).forEach(([key, value]) => {
                                acc.push({ [key]: value });
                            });
                        }
                        return acc;
                    }, [])
                    const finalresult = result.reduce((acc, obj) => {
                        return { ...acc, ...obj }
                    })

                    return finalresult

                });

                if (selPktType == 'SNG') {
                    if (mapped && mapped.length > 0) {
                        const d=mapped.filter((ele)=>ele?.party==''||ele?.party==null)
                      //  console.log(d,"dfgg",mapped)
                        const f=d.map(item => `${item.l_code}-${item.pktno}`).join(",");
                       // console.log(f,"fg")
                        setBlankParty(f)
                        let lotPktString = []
                        lotPktString = mapped.map((ele) => ele.stoneid)
                        if (lotPktString && lotPktString.length != "" && lotPktString.length > 0) {
                            findStockWithPosition({
                                data: {
                                    compcode: compCode.join(","),
                                    list: lotPktString,
                                    Ismfglist: 0,
                                    Ischkmfgmkt: 0
                                },
                                onSuccess: (data) => {
                                    if (data && data.length > 0) {
                                        console.log(data)
                                        const Stockdata = data.filter((ele) => ele.InStock == 1)
                                        const OutStockdata = data.filter((ele) => ele.InStock == 0)
                                        if (OutStockdata && OutStockdata.length > 0) {

                                            const result = OutStockdata
                                                .map(item => `${item.LotPkt}`)
                                                .join(",");

                                            show(<div className="text-red-700 text-sm" >Out Of Stock Lot No. & Pkt No. {<div style={{height:"200px",overflow:"scroll"}} className="text-gray-700 list-disc ml-5 ">
                                                {result}
                                            </div>}</div>)
                                            const d = mapped.filter((ele) => !result.split(",").includes(ele.stoneid))
                                            setExcelData(d)
                                            setoutOfStockCode(result)
                                        }

                                    }
                                }
                            })
                        }

                    }

                }
                setExcelData(mapped)

            }
            else {
                if (fileInputRef.current) {
                    fileInputRef.current.value = ''; // Clear file input
                }
                toast.error("Excel File No of Columns Mis-Match", {
                    "position": "top-center",
                    "className": "toast-error"
                })

            }

        };
        reader.readAsBinaryString(file);
    }
    console.log(excelData)
    const valueFields = [RowsField.rate, RowsField.amount, RowsField.convRate, RowsField.dRate, RowsField.dAmount];

    const handleDownloadExcel = () => {
        // File: ExportExcel.js
        // Define headersif()

        const data = [...excelTempData];

        const sortedData = data.sort((a, b) => Number(a.xl_col_no) - Number(b.xl_col_no));

        const headers = sortedData.map(ele => ele.xl_col_name)
        //if (headers && headers.length > 0) {
        //  Create a worksheet with headers only
        const ws = XLSX.utils.aoa_to_sheet([headers]);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file buffer
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Trigger download with FileSaver
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, selPktType == "SNG" ? "SinglePacketStockUploadFormat.xlsx" : "MixStockUploadFormat.xlsx");


    }
    const handleDateChange = (newValue) => {

        const cdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

        setFormData((prev) => {
            return {
                ...prev,
                [formField.memoDate]: cdate,
            };
        });
        if (cdate && cdate != "Invalid Date") {
            funMktLotNo(cdate)
        }
    }

    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);

        // ❌ Invalid format or wrong date typed
        // if (!parsed.isValid()) {
        //     toast.error("Invalid date format. Use DD/MM/YYYY", {
        //         position: "top-center",
        //         className: "toast-error"
        //     });
        //     return;
        // }

        // // ❌ Out of allowed range
        // if (parsed.isBefore(minAllowedDate) || parsed.isAfter(maxAllowedDate)) {
        //     toast.error(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`, {
        //         position: "top-center",
        //         className: "toast-error"
        //     });
        //     setFormData({ ...formData, [name]: null })
        //     return;
        // }

        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");


        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });
        if (formatted && formatted != "Invalid Date") {
            funMktLotNo(formatted)
        }
    };



    const searchInAllKeys = (data, searchText) => {
        if (!searchText) return data;

        const lowerSearch = searchText.toLowerCase();

        return data.filter(item =>
            Object.values(item).some(val =>
                val !== null &&
                val !== undefined &&
                val.toString().toLowerCase().includes(lowerSearch)
            )
        );
    };
    useEffect(() => {

    }, [])
    useEffect(() => {
        const searchData = searchInAllKeys(allRows, searchText)

        setRows(searchData)

    }, [searchText])




    if (isError) {

        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }

    return (
        <div>

            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel}   Import Bill Entry - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
                breadcrumbs={[entryLabel, "Import Bill Entry", selPktType == 'SNG' ? "Single Packet" : selPktType]}
            // prevPage={{
            //     show: true,
            //     onClick: handleClickPrev,
            // }}
            >

                <Card shadow="sm" className={stickyParentClass}>
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                            {
                                                inputBoxes[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <></>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        <Autocomplete
                                                            size="md"
                                                            name={item.name}
                                                            //isInvalid={errors[item.name]}
                                                            //  errorMessage={errors[item.name]}
                                                            label={item?.placeholder}
                                                            eventResizeFeature={true}
                                                            selectionMode="single"
                                                            showScrollIndicators={true}
                                                            labelPlacement={"outside"}
                                                            placeholder={item.placeholder}
                                                            isRequired={item.isrequired}
                                                            menuTrigger={"input"}
                                                            isLoading={isPendingData}
                                                            className="max-w-23"
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                            isClearable={false}
                                                            isVirtualized
                                                            isReadOnly={[formField.stockType].includes(item.name) && !isNewEntry ?
                                                                true : false}
                                                            defaultItems={
                                                                item.data ? item.data : []
                                                            }
                                                            onSelectionChange={(e) =>
                                                                handleAutoCompleteChange(e, '', item.name)
                                                            }
                                                            //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                            //onChange={handleFormSelectionChange}
                                                            selectedKey={formData[item.name]}
                                                        >
                                                            {(list) => (
                                                                <AutocompleteItem

                                                                    key={list[item.itemkey]}
                                                                >
                                                                    {list[item.itemvalue]}
                                                                </AutocompleteItem>
                                                            )}
                                                        </Autocomplete>
                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    value={
                                                                        formData[item.name]
                                                                            ? dayjs(formData[item.name])
                                                                            : formData[item.name]
                                                                    }
                                                                    onChange={(newValue) => handleDateChange(newValue)}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: { size: "small", onBlur: (e) => handleDateBlur(e, item.name), required: true },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : (

                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            //isInvalid={errors[item.name]}
                                                            //errorMessage={errors[item.name]}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={formData[item.name]}
                                                            variant="bordered"
                                                            onChange={(e) => handleChange(e)}
                                                            // onBlur={(e) => handleBlur(e)}
                                                            isReadOnly={item.name == [formField.memoNo] ? true : false}
                                                            size={"md"}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                            {/* {
                                isNewEntry ?
                                    <div className={`${isMobile ? "flex-wrap" : ""} text-center  mt-2 flex gap-4 justify-center items-center w-full mb-2`}>
                                        <Checkbox size="md"
                                            classNames={{ "label": "text-blue-500 font-semibold" }}
                                            className="py-1 px-2  border-blue-200 text-rose-700 border-2" label="gfu" color={"success"} isSelected={isExcelImport}
                                            onValueChange={(e) => handleCheckChange(e)}>Import From Excel</Checkbox>
                                        <Button size="sm" auto color="warning" onPress={handleDownloadExcel} className="ml-4"
                                            startContent={<FontAwesomeIcon icon={faDownload} />} >
                                            Stock Upload Excel Format
                                        </Button>
                                    </div> : ""
                            } */}
                            {isExcelImport ?
                                <div className="py-2">
                                    {isPendingStkPos ? <div className=" flex gap-1 p-2 justify-center font-semibold border-0 b-red-500 text-pink-700 text-center ">
                                        <h2 className=" px-2" >Proccessing....</h2>
                                        <Spinner size="sm" label="" className="" variant="simple" color="danger" labelColor="danger" />
                                    </div> : ""}
                                    <div className="flex gap-5 items-center">
                                        <Input type="file" color="danger" size="md" variant="flat" ref={fileInputRef}
                                            classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                                            isRequired={isExcelImport}
                                            label="Import From Excel" accept=".xlsx, .xls" onChange={handleFileUpload} ></Input>
                                        <Button size="sm" auto color="warning" onPress={handleDownloadExcel} className="px-2 w-60"
                                            startContent={<FontAwesomeIcon icon={faDownload} />} >
                                            Stock Upload Excel Format
                                        </Button>
                                    </div>
                                    <Autocomplete
                                        size="md"
                                        name={"ImportItem"}
                                        label={"Select Item"}
                                        eventResizeFeature={true}
                                        selectionMode="single"
                                        showScrollIndicators={true}
                                        labelPlacement={"outside"}
                                        variant="faded"
                                        color="default"
                                        menuTrigger={"input"}
                                        placeholder={""}
                                        isRequired={isExcelImport ? true : false}
                                        isLoading={isPendingData}
                                        className="max-w-23"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        isClearable={false}
                                        isVirtualized
                                        readonly={isNewEntry ? false : true}
                                        defaultItems={
                                            masterData && masterData.itemMaster ? masterData.itemMaster : []
                                        }
                                        onSelectionChange={setSelImportItem}                                        //color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                        selectedKey={selImportItem}
                                    >
                                        {(list) => (
                                            <AutocompleteItem

                                                key={list.Item_Code}
                                            >
                                                {list.Item_Desc}
                                            </AutocompleteItem>
                                        )}
                                    </Autocomplete>
                                    {excelData && excelData.length > 0 ? <h2 className="text-red-600 mt-3 font-semibold  p-2 bg-gray-50"> Total Packets Scheduled For Import: {excelData.length} </h2> : ""}

                                    {outOfStockCode && outOfStockCode != "" && outOfStockCode != null ? (
                                        <div className=" bg-red-50 p-2 text-sm mt-2">
                                            <h2 className="p-2  text-sm  font-semibold text-blue-700">   Out OF Stock Packets :</h2>
                                            <div className="flex gap-2 flex-wrap">
                                                {outOfStockCode}
                                            </div>
                                        </div>
                                    ) : null}

                                    {blankParty && blankParty != "" && blankParty != null ? (
                                        <div className=" bg-lime-50 p-2 text-sm mt-2">
                                            <h2 className="p-2  text-sm  font-semibold text-blue-700">  Party Name Not Found For Following Packets :</h2>
                                            <div className="flex gap-2 flex-wrap">
                                                {blankParty}
                                            </div>
                                        </div>
                                    ) : null}



                                </div> : ""}
                            <div>




                            </div>
                        </CardBody>
                        <div className={stickyBottomClass}>
                            <div className="justify-center flex items-center gap-4">
                                {/* <div className="justify-center flex gap-5 mt-5"> */}
                                <Button
                                    color="primary"
                                    type="submit"
                                    id="btnSave"
                                    size="sm"
                                    variant="shadow"
                                    tabIndex={-1}
                                    isDisabled={isPendingStkPos}
                                    isLoading={isPending}
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                               
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="sm"
                                    tabIndex={-1}
                                    // onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>

                    </form >
                </Card >
            </MainContainer>
        </div>
    )
}
export default ImportBills